import { ExerciseApi } from "../openapi";
import openApiConfig from "./http_service";

const exerciseApi=new ExerciseApi(openApiConfig)

export default exerciseApi